import { render, staticRenderFns } from "./UserActionPiece.vue?vue&type=template&id=d8e55ce0&"
import script from "./UserActionPiece.vue?vue&type=script&lang=js&"
export * from "./UserActionPiece.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports